export const CONFIRM_DETAILS_FORM_FIELDS = {
    badgeNumber: 'badgeNumber',
    noBadge: 'noBadge',
    busHubCode: 'busHubCode',
    dutyCode: 'dutyCode',
    noDuty: 'noDuty',
} as const
